export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "INITIAL_NAME": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Default name: ", _interpolate(_named("label"))])},
        "PLACEHOLDER": {
          "DATE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select date"])},
          "TEXT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Write a brief text"])},
          "LONG_TEXT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Write a text"])},
          "NUMBER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type a number"])}
        },
        "TITLE": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Edit ", _interpolate(_named("name"))])}
      }
    }
  })
}
